import styled from 'styled-components'

export const MediaList = styled.div`
    .media {
        + .media{
            margin-top: 20px;
        }
    }
`
export const Media = styled.div`
    display: flex;
    margin:0 -6px;

`
export const MediaThumb = styled.div`
    position: relative;
    width: 100%;
    padding:0 6px;
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
    aspect-ratio: 16 / 9;
    overflow: hidden;
`
export const MediaBody = styled.div`
    position: relative;
    width: 100%;
    padding:0 6px;
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
    p{
        color:#062c44;
        font-size:14px;
        line-height:20px;
        font-weight:600;
        margin-bottom:0;
        > a{
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            color:#062c44;
            &:hover, &:focus, &:active{
                color:#ed602b;
            }
        }
    }   
    small{
        font-size: 12px;
        line-height: 20px;
        display: block;
    }
`

export const ListGroup = styled.div`
   .list-item {
       padding:5px 0;
        + .list-item{
            border-top: 2px dashed #FCDDEC;
        }
   }
`
export const ListItemGroup = styled.div`
    font-weight: 600;
    font-size:16px;
    line-height: 30px;
    color: #02044A;
    &:hover, &:focus{
        color: #4815D6;
    }
`


export const ListBadge = styled.div`
	display:flex;
	flex-wrap: wrap;
	margin:0 -5px;
`
export const ListItemBadge = styled.div`
	position:relative;
	padding:0 5px;
`
export const Badge = styled.div`
	cursor: pointer;
	padding: 4px 10px;
	margin-bottom:5px;
	border: 1px solid #E0E1E4;
	background: ${props=>props.bg};
	color: ${props=>props.color};
	font-size: 14px;
	line-height: 20px;
	font-weight: 600;
	border-radius: 16px;
	.tag {
		+ .count {
			margin-left:5px;
		}
	}
	.count {
		padding: 2px 8px;
		border-radius: 12px;
		background: rgba(1, 9, 32, 0.2);
	}
`